import { StorageState } from 'context/storage/types';

export const createInitialStorageContextState = <Type>(
    contextName: string
): StorageState<Type> => ({
    getState: () => {
        throw new Error(
            `no one of your parents is a <${contextName}.Provider />!`
        );
    },
    subscribe: () => () => {},
    synchronize: () => () => {},
    update: () => {},
});
